import { z } from 'zod';

export function getAssignmentOverviewPageParamsSchema() {
  return z.object({
    assignments: z.enum(['own', 'all']).default('own'),
    groupBy: z.enum(['operator', 'user']).default('operator'),
  });
}
